import { createContext, useContext } from "react";

import type { ConfirmContextValueInterface } from "@/interfaces";

export const ConfirmContext = createContext<ConfirmContextValueInterface | null>(null);

export const useConfirm = (): ConfirmContextValueInterface => {
    const value = useContext(ConfirmContext);

    if (!value) throw new Error("useConfirm must be used within a ConfirmProvider");

    return value;
};
